import React from 'react';
import Badge from '@material-ui/core/Badge';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { Tooltip } from '@material-ui/core';
import VerifiedBadgeIcon from './VerifiedBadgeIcon';
import it from './i18n/it.json';
import en from './i18n/en.json';
import es from './i18n/es.json';
import pt from './i18n/pt.json';
import useRegisteredTranslation from '@dev-togetherprice/hooks.use-register-translation';
const TRANSLATIONS = { en, it, es, pt };
const useStyles = makeStyles(() => createStyles({
    sizeSmall: {
        width: '8px',
        height: '12px',
    },
    sizeDefault: {
        width: '18px',
        height: '22px',
    },
    sizeLarge: {
        width: '24px',
        height: '28px',
    },
    sharingCard: {
        width: '28px',
        height: '28px',
        position: 'absolute',
        top: '23px',
        right: '7px',
    },
}), { name: 'TpVerifiedBadge' });
/**
 * An opinionated badge to mark verified users.
 * This is not customizable.
 *
 *
 * It's available in 3 size `small`, `large`, `default`, `sharingCard`.
 *
 * The tooltip translations can be overridden using the namespace `VerifiedBadge`.
 * */
const VerifiedBadge = ({ size = 'sharingCard', overlap = 'rectangle', invisible = false, children, className, }) => {
    const { t } = useRegisteredTranslation('VerifiedBadge', TRANSLATIONS);
    const classes = useStyles();
    const badgeClassName = clsx({
        [classes.sizeSmall]: size === 'small',
        [classes.sizeDefault]: size === 'default',
        [classes.sizeLarge]: size === 'large',
        [classes.sharingCard]: size === 'sharingCard',
        [className]: !!className,
    });
    return (React.createElement(Badge, { classes: {
            badge: badgeClassName,
        }, badgeContent: React.createElement(Tooltip, { title: t('verified', 'This user has successfully verified an identity document.') },
            React.createElement(VerifiedBadgeIcon, { className: badgeClassName })), anchorOrigin: {
            horizontal: 'right',
            vertical: 'bottom',
        }, overlap: overlap, invisible: invisible }, children));
};
export default VerifiedBadge;
